import { useTranslation } from "react-i18next";

export function useHandler() {
  const { t } = useTranslation();

  return () => {
    window.open(t("help_center_link"), "_blank");
  };
}
